import React from "react";
import PropTypes from "prop-types";
import { cx, css } from "emotion";
import { defaultStyle, accordionHeaderStyle, accordionIconStyle } from "./style";
import { Heading } from "@maxmilhas/hangar-components-atomic/public";
import {
	green,
	yellow,
	blue,
	red
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

class Accordion extends React.PureComponent {
	state = {
		isOpen: false
	};

	render() {
		const {
			children,
			title,
			titleTag,
			accordionIcon,
			onClick,
			isOpen,
			hasError,
			selfOpenControl,
			titleColor,
			dataAction,
			...rest
		} = this.props;

		const buttonTheme = {
			green,
			yellow,
			blue,
			red
		};

		const colorToUse = buttonTheme[titleColor] ? buttonTheme[titleColor] : titleColor;

		const { isOpen: isOpenFromState } = this.state;

		const isOpenToUse = selfOpenControl === true ? isOpenFromState : isOpen;
		const headerOnClick = e =>
			selfOpenControl ? this.setState({ isOpen: !isOpenFromState }) : onClick(e);

		const accordionHeaderBaseStyle = css`
			${accordionHeaderStyle(isOpenToUse, hasError)}
		`;
		const accordionIconBaseStyle = css`
			${accordionIconStyle(isOpenToUse)}
		`;

		return (
			<section
				className={css`
					${defaultStyle}
				`}
				{...rest}
				data-action={dataAction}
			>
				<header
					className={accordionHeaderBaseStyle}
					onClick={headerOnClick}
					alt="Clique para expandir"
				>
					{title && (
						<Heading color={colorToUse} tag={titleTag} style={{ margin: 0 }}>
							{title}
						</Heading>
					)}
					<i className={cx(accordionIconBaseStyle, accordionIcon)} />
				</header>
				<div style={{ display: !isOpenToUse ? "none" : "block" }}>{children}</div>
			</section>
		);
	}
}

Accordion.propTypes = {
	children: PropTypes.any,
	title: PropTypes.string.isRequired,
	titleTag: PropTypes.string,
	titleColor: PropTypes.string,
	accordionIcon: PropTypes.string,
	isOpen: PropTypes.bool,
	selfOpenControl: PropTypes.bool,
	onClick: PropTypes.func
};

Accordion.defaultProps = {
	children: null,
	title: null,
	titleTag: "h6",
	titleColor: null,
	accordionIcon: "icon-arrow-down",
	isOpen: false,
	selfOpenControl: false,
	onClick: null
};

export default Accordion;
